import React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { PerformanceCyclesDataTableDocument } from 'generated/resources/datatable.graphql'
import { PerformanceCycleListPageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { CreateCycleModal } from 'modules/performance_cycles/components/CreateCycleModal'
import { EmptyState } from 'modules/performance_cycles/components/EmptyState'
import { PerformanceCyclesTable } from 'modules/performance_cycles/components/PerformanceCyclesTable'

const CyclesListPage = () => {
  const [openCreateCycleModal, setOpenCreateCycleModal] = React.useState(false)

  const { data, loading, error } = useQuery(PerformanceCycleListPageDocument)

  const cyclesCount = data?.performanceCycles?.cyclesConnection.totalCount
  const hasNoCycles = cyclesCount === 0

  return (
    <ResponsivePage.Body
      error={error}
      loading={loading}
      header={{
        description: hasNoCycles ? '' : i18n.t('performance_cycles.description'),
      }}
    >
      <Box gap="s16">
        {hasNoCycles ? (
          <EmptyState onClick={() => setOpenCreateCycleModal(true)} />
        ) : (
          <PerformanceCyclesTable
            actions={
              <Button iconName="add" onClick={() => setOpenCreateCycleModal(true)}>
                {i18n.t('performance_cycles.new_cycle')}
              </Button>
            }
            refetchQueries={[PerformanceCycleListPageDocument]}
          />
        )}
      </Box>

      {openCreateCycleModal && (
        <CreateCycleModal
          onClose={() => setOpenCreateCycleModal(false)}
          refetchQueries={[PerformanceCyclesDataTableDocument, PerformanceCycleListPageDocument]}
        />
      )}
    </ResponsivePage.Body>
  )
}

export default CyclesListPage
